<template>
    <div>
        <el-form :inline="true" :model="searchForm"  class="forTbFilter">
             <el-form-item label="代理商：" prop="agentId">
                    <el-select v-model="searchForm.agentId" filterable>
                        <el-option v-for="item in agentsOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            <el-form-item label="运营商名称："> 
                <el-select v-model="searchForm.supplierId" clearable>
                    <el-option v-for="item in supplierOption" :value="item.id" :key="item.id" :label="item.supplierName"></el-option>
                </el-select>
            </el-form-item>
                <el-form-item label="ICCID：">
                <el-input v-model.trim="searchForm.iccid" clearable></el-input>
            </el-form-item>
             <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                 <el-button type="primary"  @click="getFluxPoolMgtListHandler">搜索查询</el-button>
                 <el-button type="success" @click="exportOrderInfoHandle">导出Excel</el-button> 
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="iccid" label="ICCID"></el-table-column>
            <el-table-column prop="agentPathName" label="所属代理商"></el-table-column>
            <el-table-column prop="supplierName" label="运营商"></el-table-column>
            <el-table-column prop="remark" label="失败原因" width="620"></el-table-column>            
            <el-table-column prop="importNum" label="导入批次" width="80"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
          
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>
        <el-dialog :title="title" :visible.sync="poolVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="poolForm" :model="poolForm" :rules="poolRules" label-width="120px">
                <el-form-item label="流量池名称：" prop="poolName">
                    <el-input v-model="poolForm.poolName"></el-input>
                </el-form-item>
                <el-form-item label="代理商：" prop="agentId">
                    <el-select v-model="poolForm.agentId" filterable>
                        <el-option v-for="item in agentsOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="供应商：" prop="supplierId">
                    <el-select v-model="poolForm.supplierId" clearable>
                        <el-option v-for="item in supplierOption" :value="item.id" :key="item.id" :label="item.supplierName"></el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="池子类型：" prop="type">
                    <el-select v-model="poolForm.type" filterable>
                        <el-option v-for="item in typesOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="CT流量池ID：" prop="groupId">
                    <el-input v-model="poolForm.groupId" placeholder="CT卡必填"></el-input>
                </el-form-item>
                 <el-form-item label="单卡流量/M：" prop="simData">
                    <el-input v-model="poolForm.simData" placeholder="自运营必填"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureAddOrEditFluxPool">确 定</el-button>
            </div>
        </el-dialog>     
    </div>
</template>

<script>
import {getFluxPoolMgtLists, addFluxPool, editFluxPool} from '@/api/fluxPool.js'
import common from '@/utils/common.js'
export default {
    data(){         
        return {
            searchForm: {
                iccid:null,
                supplierId:null,
                time:'',
                agentId:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  
            poolVisibale: false,
            title: '新增流量池',
            optFlag: '',
            poolForm: {
                currentId: null,
                poolName: '',
                agentId: '',
                supplierId: '',
                groupId:'',
                simData:'',
                type:''
            },
            typesOption:[

                {
                    id:'0',
                    name:'运营商流量池'
                },
                {
                    id:'1',
                    name:'自运营流量池'
                }
            ],
            supplierOption: [],
            agentsOption: [],
             pkgsOption:[],
            poolRules: {
                poolName: [{required: true, message: '请输入流量池名称', trigger: 'blur'}],
                agentId: [{required: true, message: '请选择代理商', trigger: 'blur change'}],
                supplierId: [{required: true, message: '请选择供应商', trigger: 'blur change'}],
                groupId: [{required: false, message: 'CT卡必填', trigger: 'blur'}],
            }
        }
    },
    methods: {
        cancel(){
            this.poolVisibale = false;
            this.$refs.poolForm.resetFields();
        },
        getFluxPoolMgtListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            getFluxPoolMgtLists(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showAddFluxPool(){
            this.poolVisibale = true;
            this.title = '新增流量池';
            this.optFlag = 'add';
           
        },
        showEditFluxPool(row){
            this.poolVisibale = true;
            this.title = '编辑增流量池';
            this.optFlag = 'edit';
            common.getSupplierOptsCom(this, 'supplierOption')
            common.getNextAgentOptsCom(this, 'agentsOption');
            this.poolForm = JSON.parse(JSON.stringify(row));
        },
        sureAddOrEditFluxPool(){
            this.$refs.poolForm.validate(valid => {
                if(valid){
                    var data = this.poolForm
                    if(this.optFlag == 'add'){
                        addFluxPool(data).then(res => callback(res))
                    }else{
                        editFluxPool(data).then(res => callback(res))
                    }
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.getFluxPoolMgtListHandler();
                        _this.poolVisibale = false;
                        
                    }else{
                        _this.$message.error(res.data.message)
                    }                     
                }
            })
        },
         exportOrderInfoHandle($event){
              common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);    
            data.token = localStorage.getItem('token');
            data.pageSize = 10000;
            data.prePageNum = 10000;
             common.sysRequest('excels/admin/order/sim/all/fail', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success('下载中，请稍后在下载管理中查询');
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getFluxPoolMgtListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getFluxPoolMgtListHandler();
        }       
    },
    created () {
        common.getNextAgentOptsCom(this, 'agentsOption');
        this.getFluxPoolMgtListHandler();
         common.getSupplierOptsCom(this, 'supplierOption');
            common.getNextAgentOptsCom(this, 'agentsOption');  

    }
}
</script>

<style lang="scss" scoped>

</style>

